// Angular
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgApexchartsModule } from 'ng-apexcharts';
// NgBootstrap
import { NgbDropdownModule, NgbTabsetModule, NgbTooltipModule, NgbProgressbarModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Perfect Scrollbar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// Core module
import { InitialsPipe } from './content/dashboard-widgets/widget6-conversations/pipes/initials.pipe';
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxSpinnerModule } from "ngx-spinner";
import { SharedModule} from '../../shared/shared.module';

import {
    Widget1SalesStatComponent,
    Widget2RecentActivitiesComponent,
    Widget3ContactComponent,
    Widget4CompanyComponent,
    Widget5OpportunityComponent,
    Widget6ConversationsComponent
  } from './content/dashboard-widgets';
  import { Widget7WhatsappConversationsComponent } from './content/dashboard-widgets/widget7-whatsapp-conversations/widget7-whatsapp-conversations.component';
import { HttpClientModule } from '@angular/common/http';
import { WaTemplateListComponent } from './content/dashboard-widgets/widget7-whatsapp-conversations/_subs/wa-template-list/wa-template-list.component';



@NgModule({
  declarations: [
    Widget1SalesStatComponent,
    Widget2RecentActivitiesComponent,
    Widget3ContactComponent,
    Widget4CompanyComponent,
    Widget5OpportunityComponent,
    Widget6ConversationsComponent,
    InitialsPipe,
    Widget7WhatsappConversationsComponent,
    WaTemplateListComponent
  ],
  exports: [
    Widget1SalesStatComponent,
    Widget2RecentActivitiesComponent,
    Widget3ContactComponent,
    Widget4CompanyComponent,
    Widget5OpportunityComponent,
    Widget6ConversationsComponent,
    Widget7WhatsappConversationsComponent
  ],
  entryComponents:[WaTemplateListComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    InlineSVGModule,
    NgApexchartsModule,
    // angular material modules
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    MatInputModule,
    MatTableModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatIconModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatCardModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTabsModule,
    MatTooltipModule,
    MatDialogModule,

    // ng-bootstrap modules
    NgbDropdownModule,
    NgbTabsetModule,
    NgbTooltipModule,
    NgbProgressbarModule,
    NgxSpinnerModule,
    NgbModule,
    SharedModule,
    HttpClientModule
  ],
})
export class CompanyPartialsModule {
}
